import { getFeaturedGameExcerpt } from '@/lib/featured-game-excerpts'
import { useI18n } from '@/lib/i18n'
import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

export function FeaturedGameExcerpt() {
  const { language, t } = useI18n()
  const excerpt = getFeaturedGameExcerpt(language)

  return (
    <section
      id="featured-game"
      data-testid="featured-game"
      dir={language === 'ar' ? 'rtl' : 'ltr'}
      className="bg-[#071322] px-6 py-16 text-[#fff8e8] sm:px-8 md:py-24"
    >
      <div className="mx-auto max-w-4xl">
        <h2 className="mb-8 text-2xl font-semibold tracking-tight text-[#fff8e8] sm:text-3xl">
          {t('play.gameLog')}
        </h2>
        <div className="featured-game-card rounded-2xl border border-[#a88a5d]/60 bg-[#102131] p-5 shadow-[0_18px_48px_rgba(0,0,0,0.2)] sm:p-8">
          <article data-testid="featured-speech">
            <div className="mb-4 flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <h3 dir="auto" className="text-lg font-semibold text-[#f6d891]">
                {excerpt.speaker}
              </h3>
              <span className="featured-game-seat text-sm text-[#ddd0b5]">
                {t('game.seat', { num: excerpt.seat })}
              </span>
              <span
                data-testid="featured-role"
                className="text-sm text-[#f6d891]"
              >
                {t(`game.${excerpt.role}`)} <span aria-hidden="true">🐺</span>
              </span>
              <span
                data-testid="featured-model"
                className="featured-game-model text-sm text-[#ddd0b5]"
              >
                {t('leaderboard.aiModel')}:{' '}
                <bdi dir="ltr" className="break-all">
                  {excerpt.model}
                </bdi>
              </span>
            </div>
            <div
              data-testid="featured-speech-text"
              lang={excerpt.originalLanguage}
              dir={excerpt.originalLanguage === 'en' ? 'ltr' : 'auto'}
              className="h-[17rem] overflow-hidden break-words text-base leading-7 text-[#f1eadc] sm:text-lg sm:leading-8"
            >
              <ReactMarkdown
                remarkPlugins={[remarkGfm, remarkBreaks]}
                components={{
                  p: ({ children }) => (
                    <p className="mb-4 last:mb-0">{children}</p>
                  ),
                  strong: ({ children }) => (
                    <strong className="font-bold">{children}</strong>
                  ),
                  em: ({ children }) => <em className="italic">{children}</em>,
                }}
              >
                {excerpt.text}
              </ReactMarkdown>
            </div>
          </article>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <Link
              to={`/play/${excerpt.gameId}`}
              data-testid="featured-full-replay"
              className="inline-flex min-h-11 items-center rounded-lg px-2 text-base font-semibold text-[#f6d891] underline underline-offset-4 transition-colors hover:text-[#fff8e8] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#f6d891]"
            >
              {t('game.openFullReplay')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
